import { HttpRequestPost } from "../../service";

export function getWeeklySummary(isAdmin, body, success, fail) {
  let url = isAdmin ? '/admin/weeklysummaries' : '/merchant/weeklysummaries';
  return HttpRequestPost(
    url,
    () => undefined,
    (res) => success(res.Result),
    (err) => fail(err),
    true,
    body
  );
}

export function exportCSV(isAdmin, body, success, fail) {
  let url = isAdmin ? '/admin/agencyfees/csv-export' : '/merchant/agencyfees/csv-export';
  return HttpRequestPost(
    url,
    () => undefined,
    (res) => success(res.Result),
    (err) => fail(err),
    true,
    body
  );
}
